import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createTheme, MantineProvider } from "@mantine/core";
import { Toaster } from "react-hot-toast";

const theme = createTheme({
  fontFamily: "Space Grotesk, sans-serif",
  headings: {
    fontFamily: "Space Grotesk, sans-serif",
    fontWeight: "700",
  },
  defaultRadius: "md",
  white: "#ffffff",
  black: "#1A1B1E",
  primaryColor: "blue",
  components: {
    Button: {
      defaultProps: {
        fw: 600,
      },
      styles: {
        root: {
          transition: "all 0.15s ease",
        },
      },
    },
    Paper: {
      defaultProps: {
        withBorder: true,
        shadow: "sm",
      },
    },
    TextInput: {
      styles: {
        label: {
          fontWeight: 600,
          fontSize: "12px",
          marginBottom: 4,
        },
      },
    },
    Select: {
      styles: {
        label: {
          fontWeight: 600,
          fontSize: "12px",
          marginBottom: 4,
        },
      },
    },
    NavLink: {
      styles: {
        root: {
          borderRadius: "var(--mantine-radius-md)",
          marginBottom: 4,
          fontWeight: 500,
        },
      },
    },
    Modal: {
      styles: {
        header: {
          fontWeight: 700,
          paddingBottom: 15,
        },
      },
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <MantineProvider theme={theme}>
      <App />
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            fontFamily: "Space Grotesk, sans-serif",
            fontSize: "13px",
          },
          success: { duration: 3000 },
          error: { duration: 6000 },
        }}
      />
    </MantineProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
